import { Component } from "@opten/compiler/metadata/component";

@Component({ className: 'js-sidebar'})
export class SidebarComponent {
	private open = [];
	private openedTab: Element;
	private contents: Element;

	constructor(private element: HTMLElement) {
		const tabs = element.getElementsByClassName('js-sidebar-button');
		this.contents = element.getElementsByClassName('js-sidebar-contents')[0];

		Array.from(tabs).forEach(tab => {
			const tabContentId = tab.getAttribute('data-target');

			if (tabContentId) {
				tab.addEventListener('click', () => {
					
					const index = this.open.indexOf(tabContentId);
					
					if (index > -1) {
						this.closeTab(tabContentId, tab);
					} else {
						this.openTab(tabContentId, tab);
					}
				});
			}
		});

		const closeIcons = Array.from(element.getElementsByClassName('js-sidebar-close'));
		
		if (closeIcons) {
			closeIcons.forEach(closeIcon => {

				closeIcon.addEventListener('click', () => {
					this.checkOpenTabsAndClose(null);
				});
			});
		}
	}

	private checkOpenTabsAndClose(clickedTab: string) {
		const openTabs = this.open.filter(o => o !== clickedTab);

		openTabs.forEach(tabContentId => {
			this.closeTab(tabContentId);
		});
	}

	private closeTab(tabContentId: string, tab = null) {

		if (this.openedTab) {
			this.openedTab.classList.remove('-selected');
		}

		const tabContent = document.getElementById(tabContentId);

		if (tabContent) {

			const index = this.open.indexOf(tabContentId);
			this.open.splice(index, 1);

			if (this.open.length < 1 && this.contents) {
				this.contents.classList.remove('-open');
				
				window.setTimeout(() => {
					tabContent.classList.remove('-open');
				}, 350);
			} else {
				tabContent.classList.remove('-open');
			}
		}
	}

	private openTab(targetId: string, tab: Element) {

		const content = document.getElementById(targetId);

		if (content && this.contents) {
			
			this.open.push(targetId);
			this.checkOpenTabsAndClose(targetId);

			this.openedTab = tab;
			this.openedTab.classList.add('-selected');

			this.contents.classList.add('-open');
			content.classList.add('-open');
		}
	}
}